
import O1HD, { modules } from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import { UI_Z_INDEX } from "../../../../../engines/modules/uiModule";
import PageBase from "../../../../../engines/modules/uiModule/PageBase";
import { OilFieldBuyPrams } from "../../../../../engines/modules/uiModule/UIPrams";
import ModelDialogLayer from "../../../../gameCommon/basic/ModelDialogLayer";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab } from "../../../BundleResourceConfig";
import { KaoguDataHelp } from "./config/kaoguDataHelp";
import { getKaoguItemConfig, getKaoguMountainConfig, isMine, KaoguMountainInfo } from "./config/kaoguMountainConfig";
import SearchLight from "./SearchLight";

const { ccclass, property } = cc._decorator;

@ccclass
export default class kaoguMinePage extends cc.Component {
    @property({ type: cc.Node, displayName: "火把" })
    node_fire: cc.Node = null;
    @property({ type: cc.Node, displayName: "物品列表" })
    itemGroup: cc.Node = null;
    @property({ type: cc.Node, displayName: "飞动物品列表" })
    other_itemGroup: cc.Node = null;
    @property({ type: cc.Label, displayName: "泥土物件数量" })
    lab_insideNum: cc.Label = null;
    insideNum: number = 0;
    mountainInfo: KaoguMountainInfo = null;
    @property({ type: SearchLight, displayName: "黑幕" })
    node_mask: SearchLight = null;
    onLoad() {

        this.node_fire.on(cc.Node.EventType.TOUCH_START, this.touchBegin, this);
        this.node_fire.on(cc.Node.EventType.TOUCH_MOVE, this.touchMove, this);
        this.node_mask.node.active = true;
        // const t=cc.tween(this.node_mask).to(0.3)
    }
    insideNodeList: cc.Node[] = [];
    outsideNodeList: cc.Node[] = [];
    getPos(minY: number, maxY: number) {
        let x, y: number = null;
        while (1) {
            x = data_control.getRandNumberOfArrayTwo([-300, 200]);
            y = data_control.getRandNumberOfArrayTwo([minY, maxY]);
            for (let node of this.insideNodeList) {
                if (node.getPosition().sub(cc.v2(x, y)).mag() < 500) continue;
            }
            for (let node of this.outsideNodeList) {
                if (node.getPosition().sub(cc.v2(x, y)).mag() < 500) continue;
            }
            break;
        }
        return cc.v2(x, y)
    }
    async init(id: number) {
        this.mountainInfo = getKaoguMountainConfig[id];


        {
            // outside
            let num = this.mountainInfo.outsideNumList[data_control.getRandIPosByWeights(this.mountainInfo.outsideNumProList)]

            let outsideIDList = this.mountainInfo.outsideIDList.concat();
            let outsideList = this.mountainInfo.outsideProList.concat();


            let idList: number[] = [];
            while (1) {
                if (num <= 0) break;
                let index = data_control.getRandIPosByWeights(outsideList)
                // console.warn("概率不对吗地面", outsideList, outsideIDList)
                idList.push(outsideIDList[index]);
                outsideIDList.splice(index, 1)
                outsideList.splice(index, 1)
                num--;
            }


            //埋在土里和矿物
            console.log("地面物品ID列表", idList)
            for (let id of idList) {
                const info = getKaoguItemConfig[id];
                let outsideMaxY = isMine(id) ? -290 : -400;
                let outsideMinY = isMine(id) ? -340 : -570;
                let prefab: string = isMine(id) ? '/mineitem' : '/outsideitem';
                let node //= await LoadHelp.loadPrefabPromise("prefab/kaogu/item/" + id + prefab + id);
                // if (!node)
                let prefab2 = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.kaogu, "kaogu/item/" + 0 + prefab + 0, false);

                node = cc.instantiate(prefab2);
                this.loadBottonImg(node.children[0].getComponent(cc.Sprite), info.spriteimg, isMine(id))
                node.setParent(this.itemGroup)
                node.setPosition(this.getPos(outsideMinY, outsideMaxY));
                this.outsideNodeList.push(node);
                node.targetOff(this);
                node.on(cc.Node.EventType.TOUCH_START, this.checkStart.bind(this, id, node))
                node.on(cc.Node.EventType.TOUCH_CANCEL, this.checkCancel.bind(this, id, node))
                node.on(cc.Node.EventType.TOUCH_END, this.checkEnd.bind(this, id, node, true, isMine(id)))
            }
            this.outsideNodeList.sort((a, b) => { return b.y-a.y })
            for (let i = 0, len = this.outsideNodeList.length; i < len; i++)this.outsideNodeList[i].zIndex = i
        }


        {
            // inside
            const insideMaxY = 350;
            const insideMinY = 0;
            let num = this.mountainInfo.insideNumList[data_control.getRandIPosByWeights(this.mountainInfo.insideNumProList)]
            let insideIDList = this.mountainInfo.insideIDList.concat();
            let insideList = this.mountainInfo.insideProList.concat();

            let idList: number[] = [];
            if(KaoguDataHelp.isfirst){
                // 
                idList.push(7)
                num--;
                KaoguDataHelp.isfirst = false;
            }
            while (1) {
                if (num <= 0) break;
                let index = data_control.getRandIPosByWeights(insideList)
                console.warn("概率不对吗", insideList, insideIDList)
                idList.push(insideIDList[index]);
                insideIDList.splice(index, 1)
                insideList.splice(index, 1)
                num--;
            }

            console.log("泥土内物品ID列表", idList)
            for (let id of idList) {

                let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.kaogu, "kaogu/item/" + id + "/insideitem" + id, false);
                if (!prefab) prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.kaogu, "kaogu/item/" + 0 + "/insideitem" + 0, false);

                let node = cc.instantiate(prefab);
                node.setParent(this.itemGroup)
                node.setPosition(this.getPos(insideMinY, insideMaxY));
                this.insideNodeList.push(node);

                node.targetOff(this);
                node.on(cc.Node.EventType.TOUCH_START, this.checkStart.bind(this, id, node))
                node.on(cc.Node.EventType.TOUCH_CANCEL, this.checkCancel.bind(this, id, node))
                node.on(cc.Node.EventType.TOUCH_END, this.checkEnd.bind(this, id, node, false))
            }
            this.insideNodeList.sort((a, b) => { return  b.y-a.y })
            for (let i = 0, len = this.insideNodeList.length; i < len; i++)this.insideNodeList[i].zIndex = i
        }





        this.scheduleOnce(() => {
            this.setFirePos();
        })
    }


    async loadBottonImg(sprite: cc.Sprite, url: string, isMine: boolean) {
        let st = isMine ? 'res/kaogu/kaoguitem/' : 'res/kaogu/kaoguMineItem/';
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.kaogu, false);
        await new Promise<void>(resolve=>{
            bundle.load(st + url, cc.Texture2D, (e, ass: cc.Texture2D) => {
                if (e) {
                    console.warn(e, '矿内显示图片出错')
                    sprite.spriteFrame = null
                    resolve();
                    return
                }
                sprite.spriteFrame = new cc.SpriteFrame(ass);
                resolve();
            });
        });
       
    }

    checkStart(id: number, node: cc.Node, a2) {
        // 如果在范围内就有动画
        if (node.convertToWorldSpaceAR(cc.v2(0, 0)).sub(this.lightWordPos).mag() < 250) {
            node.scale = 1.1;
        }
    }
    checkCancel(id: number, node: cc.Node, a2) {
        if (node.scale != 1) node.scale = 1;
    }
    protected update(dt: number): void {
        this.lab_insideNum.string = `x${KaoguDataHelp.getEarthIDList().length}`
    }
    over: boolean = false;
    async setGameOver() {
        if (this.over) return;
        if (this.itemGroup.childrenCount <= 0) {
            this.over = true;
            // 全部获取完了 直接进刮
            ModelDialogLayer.show('当前矿山已完全探索完，\n前往查看收取的泥土物件'
            , ()=> {
                this.onClickBack();
            }, ()=> {
                this.onClickGuaEarth();
                this.onClickBack();
            }
            , '前往查看'
            , '下次再看'
            );
        }
    }
    private getList: string[] = []
    async checkEnd(id: number, node: cc.Node, isout: boolean, isMine: boolean = false) {
        if (node.convertToWorldSpaceAR(cc.v2(0, 0)).sub(this.lightWordPos).mag() < 250) {
            node.scale = 1;

            if (this.getList.includes(node.uuid)) {
                return
            }
            this.getList.push(node.uuid);
            // 点击了 那就获取
            if (isout) {
                const ani = node.getChildByName('ani').getComponent(sp.Skeleton);
                ani.node.active = true;
                const fun = async () => {
                    node.destroy();
                    // 地面上的物品直接卖
                    let page: PageBase;
                    let prams: OilFieldBuyPrams = {
                        id: id,
                        callBack: async () => {
                            // 卖出了
                            let info = getKaoguItemConfig[id];
                            if (info.sellPrice != 0) {
                                O1HD.getServices().userSrv.setCoins(info.sellPrice, true, this.node);
                            }
                            this.setGameOver();
                        },
                        rightcallBack:async () => {
                            // 3倍卖出了
                            let info = getKaoguItemConfig[id];
                            if (info.sellPrice != 0) {
                                O1HD.getServices().userSrv.setCoins(2*info.sellPrice, true, this.node);
                            }
                            this.setGameOver();
                        },
                    }
                    page = await modules().uiControlModule.OpenPage("kaogu/outsideItemPage", UI_Z_INDEX.DIALOG, prams, getOneBundleByInstant(BUNDLE_SMALL_NAME.kaogu), true);
                }
                if (isMine) {
                    node.getChildByName("Glow").active = false;
                    ani.setAnimation(0, 'Gao_Shi_01', false);
                    O1HD.getManagers().soundMgr.playSound("kaogu/minetu");
                    ani.setCompleteListener(() => {
                        ani.setAnimation(0, 'Gao_Shi_01', false);
                        O1HD.getManagers().soundMgr.playSound("kaogu/minetu");
                        ani.setCompleteListener(() => {
                            ani.setAnimation(0, 'Gao_Shi_02', false);
                            O1HD.getManagers().soundMgr.playSound("kaogu/minetu");
                            ani.setCompleteListener(() => {
                                ani.node.active = false;
                                node.setParent(this.other_itemGroup);
                                cc.tween(node)
                                    .to(0.5, { x: 0, y: 0 })
                                    .delay(0.3)
                                    .call(() => {
                                        fun && fun()

                                    })
                                    .start()
                            })
                        })
                    })
                } else {
                    O1HD.getManagers().soundMgr.playSound("kaogu/minedi");;
                    ani.setAnimation(0, 'Gao_Di', false);
                    ani.setCompleteListener(() => {
                        fun && fun();
                    })
                }
            } else {
                O1HD.getManagers().soundMgr.playSound("kaogu/minetu");
                const ani = node.getChildByName('ani').getComponent(sp.Skeleton);
                ani.node.active = true;
                ani.setAnimation(0, 'Gao_Di', false);
                ani.setCompleteListener(() => {
                    node.targetOff(this);
                    node.children[0].active = false;
                    node.children[1].active = true;
                    ani.node.active = false;
                    node.setParent(this.other_itemGroup);
                    let pos = this.other_itemGroup.convertToNodeSpaceAR(this.lab_insideNum.node.parent.convertToWorldSpaceAR(cc.v2(0, 0)))
                    let startPos = node.getPosition();
                    cc.tween(node)
                        .to(0.2, { scale: 1.1 })
                        .to(0.2, { scale: 1 })
                        .bezierTo(0.5, startPos, cc.v2(startPos.x, startPos.y + 300), pos)
                        .call(() => {
                            KaoguDataHelp.setEarthIDList(id)
                            node.destroy();
                            this.setGameOver();
                        })
                        .start()
                })
                // 泥土内的
                // let page: PageBase;
                // let prams: OilFieldBuyPrams = {
                //     id: id,
                //     callBack: async () => {
                //         KaoguDataHelp.setEarthIDList(id)
                //     }
                // }
                // page = await modules().uiControlModule.OpenPage("prefab/kaogu/insideItemPage", UI_Z_INDEX.DIALOG, prams, O1HD.getManagers().gameMgr.getCurrMode().bundle);

            }
        }
    }


    lightWordPos: cc.Vec2 = null;
    setFirePos() {
        this.lightWordPos = this.node_fire.parent.convertToWorldSpaceAR(cc.v2(this.node_fire.x - 50, this.node_fire.y + 210))
        this.node_mask.setPos(this.lightWordPos);
    }
    public touchBegin(event: cc.Event.EventTouch) {
        this.node_fire.parent.x += event.getDeltaX();
        this.node_fire.parent.y += event.getDeltaY();
        this.node_fire.parent.y = data_control.getValueOfAreaMinMax(this.node_fire.parent.y, -cc.winSize.height / 2 + 30, cc.winSize.height / 2 - 200)
        // this.node_fire.setPosition(this.node_fire.parent.convertToNodeSpaceAR(event.getLocation()))
        this.setFirePos();
    }

    public touchMove(event: cc.Event.EventTouch) {
        this.node_fire.parent.x += event.getDeltaX();
        this.node_fire.parent.y += event.getDeltaY();
        this.node_fire.parent.y = data_control.getValueOfAreaMinMax(this.node_fire.parent.y, -cc.winSize.height / 2 + 30, cc.winSize.height / 2 - 200)
        this.setFirePos();
    }

    async onClickBack() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        // 判断有没有全部弄完
        if (this.itemGroup.childrenCount > 0) {
            ModelDialogLayer.show('当前矿山还没有完全探索完，\n退出后将无法继续本次探索，\n是否退出？'
            , ()=> {

            }, ()=> {
                this.node && this.node.isValid && this.node.destroy();
            }
            , '退 出'
            , '留 下'
            );
        } else this.node && this.node.isValid && this.node.destroy();
    }

    async onClickGuaEarth() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        if (!KaoguDataHelp.getEarthIDList() || KaoguDataHelp.getEarthIDList().length <= 0) {
            modules().uiControlModule.showMessageBox("无泥土物件");
            return
        }

        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.kaogu, "kaoguArticle/kaoguArticlePage");
        let node = cc.instantiate(prefab);
        O1HD.Canvas().addChild(node);
    }
}